import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { publicRoutes, authProtectedRoutes } from "routes";
import 'react-multi-carousel/lib/styles.css';
import 'react-range-slider-input/dist/style.css';
import 'react-day-picker/dist/style.css';
import AppRoute from "routes/router";

function App() {
  return (
    <div className={["font-poppins h-full"].join(" ")}>
      <Router>
        <Routes>
          {publicRoutes.map((item, key) => (
            <Route key={key} element={item.element} path={item.path} />
          ))}
          <Route element={<AppRoute />}>
            {authProtectedRoutes.map((item, key) => (
              <Route key={key} element={item.element} path={item.path} exact={item.exact} />
            ))}
          </Route>
        </Routes>
      </Router>
      {/* <ToastComponent /> */}
    </div>
  );
}

export default App;
